
import React, { useState } from 'react';
import { Box, Button, Typography, Tooltip, IconButton, useTheme } from '@mui/material';
import { useThemeContext } from '../context/ThemeContext';
import { useNavbarLogic } from '../hooks/navbar/useNavbarLogic';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import SystemSelectorModal from './SystemSelectorModal';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';

const NavbarActions: React.FC = () => {
  const theme = useTheme()
  const { darkMode, toggleDarkMode } = useThemeContext();
  const {
    selectedSystemName,
    handleNavigation,
  } = useNavbarLogic();
  const [isModalOpen, setModalOpen] = useState(false);
  return (
    <Box display="flex" alignItems="center">
      <Button
        variant="outlined"
        size="small"
        onClick={() => setModalOpen(true)}
        sx={{
          minWidth: 150,
          maxWidth: 500,
          textTransform: 'none',
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          borderColor: theme.palette.primary.light,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingRight: 1.5,
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        }}
        endIcon={<ArrowDropDownIcon />}
      >
        <Typography
          variant="subtitle1" // Adjust as needed (e.g. 'body1', 'h6', etc.)
          noWrap
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: 'calc(100% - 24px)', // leave room for icon
          }}
        >
          {selectedSystemName}
        </Typography>
      </Button>

      <SystemSelectorModal
        open={isModalOpen}
        onClose={() => setModalOpen(false)}
      />

      <Tooltip title={darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}>
        <IconButton
          onClick={toggleDarkMode}
          sx={{
            color: theme.palette.text.primary,
            minWidth: '48px',
            minHeight: '48px',
            marginLeft: 2,
          }}
        >
          {darkMode ? <LightModeIcon /> : <DarkModeIcon />}
        </IconButton>
      </Tooltip>

      <Tooltip title="Manage Accounts">
        <IconButton
          onClick={() => handleNavigation('/account')}
          sx={{
            color: theme.palette.text.primary,
            marginLeft: 1,
            minWidth: '48px',
            minHeight: '48px',
          }}
        >
          <AccountCircleIcon />
        </IconButton>
      </Tooltip>

      <Tooltip title="Logout">
        <IconButton
          onClick={() => handleNavigation('/logout')}
          sx={{
            color: theme.palette.text.primary,
            marginLeft: 1,
            minWidth: '48px',
            minHeight: '48px',
          }}
        >
          <LogoutIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
export default NavbarActions;